import React from 'react'
import refferbg from "../assets/reffer-bg.png"
import refferbirdmoney from "../assets/refferbirdmoney.gif"
import topbird from "../assets/topbird.gif"

const Reffer = () => {
    return (
        <>
         <div className='h-full md:w-[1442px] w-full flex items-center justify-center flex-col'>
            <div className='bg-cover md:w-full w-screen bg-no-repeat md:px-32 px-5 py-10 flex'
            style={{
                backgroundImage:`url(${refferbg})`,
                backgroundPosition:"center"
            }}
            >
                <div>
                <h1 className='md:text-[5rem] text-[2rem]'>Invite</h1>
                <h1 className='md:text-[5rem] text-[2rem]'> Your Freind</h1>
                <h3 className='md:w-[70%]'>And get 10% Commission of the $FLAPPY they buy on Pre-Sale!</h3>
                </div>
                <div className='flex items-center justify-between md:w-2/4 w-2/3 md:ml-16 -mt-12 md:mt-0'>
      <img src={refferbirdmoney} alt="" className='md:h-48 md:w-48 h-24 w-24'/>
      <img src={topbird} alt="" className='md:h-40 md:w-40 h-24 w-24 backward'/>
      </div>

            </div>
            </div>
        </>
    )
}

export default Reffer
